import React from 'react';
export function Hero() {
  return <section className="relative bg-primary py-20 lg:py-24 overflow-hidden" data-id="element-362">
      <div className="absolute inset-0 bg-gradient-to-br from-header to-primary opacity-90" data-id="element-363" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-364">
        <h1 className="load-fade-in-up text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight" data-id="element-365">
          Privacy Policy
        </h1>
        <p className="load-fade-in-up stagger-1 text-lg text-blue-100" data-id="element-366">
          Last updated: April 4, 2026
        </p>
      </div>
    </section>;
}